import { Component, computed, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';

import { TranslatePipe } from '@recruitee/i18n';
import type { Placement } from '@recruitee/placements-types';
import {
  BadgeComponent,
  CollapsedCardChildComponent,
  CollapsibleCardComponent,
  ConnectedOverlayDirective,
  DropdownComponent,
  DropdownItemComponent,
  DropdownWidth,
  HeadingComponent,
  IconButtonComponent,
  IconComponent,
  InterviewEvaluationRatingComponent,
  OverlayOriginDirective,
  RtTooltip,
  TruncateComponent,
} from '@recruitee/user-interface';

import { CandidateOfferTooltipComponent } from '../candidate-offer-tooltip/candidate-offer-tooltip.component';
import { CollapsibleCardAnalyticsDirective } from '../collapsible-card/collapsible-card-analytics.directive';

@Component({
  selector: 'rt-candidate-profile-talent-pools',
  templateUrl: './candidate-profile-talent-pools.component.html',
  styleUrls: ['./candidate-profile-talent-pools.component.less'],
  imports: [
    CollapsibleCardComponent,
    BadgeComponent,
    CollapsedCardChildComponent,
    HeadingComponent,
    TranslatePipe,
    IconComponent,
    IconButtonComponent,
    RouterLink,
    TruncateComponent,
    OverlayOriginDirective,
    ConnectedOverlayDirective,
    DropdownComponent,
    DropdownItemComponent,
    InterviewEvaluationRatingComponent,
    CollapsibleCardAnalyticsDirective,
    RtTooltip,
    CandidateOfferTooltipComponent,
  ],
})
export class CandidateProfileTalentPoolsComponent {
  protected readonly DropdownWidth = DropdownWidth;

  public candidateId = input.required<number>();
  public canManageCandidates = input.required<boolean>();
  public hasNewTalentPools = input.required<boolean>();
  public placements = input.required<Placement[]>();
  public talentPoolKey = computed(() => (this.hasNewTalentPools() ? 'talentPool' : 'offer'));
  public removeClick = output<{
    placementId: number;
  }>();

  public removeFromTalentPool(placement: Placement) {
    this.removeClick.emit({ placementId: placement.id });
  }
}
